module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'a29bfri3',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
